import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBgPrimaryMediumLight, colorIcon } = theme();

  const styles = StyleSheet.create({
    icon: {
      marginHorizontal: 12,
    },
  });

  return {
    ...styles,
    colorBgPrimaryMediumLight,
    colorIcon,
  };
};

export { style };
